﻿import * as signalR from "@microsoft/signalr";

export class EventHub {
    static URL = "/eventHub";
    static SUBSCRIBE = "Subscribe";
    static UNSUBSCRIBE = "Unsubscribe";

    // private fields
    #connection;
    #subscribedEvents;

    /** https://learn.microsoft.com/en-us/aspnet/core/signalr/javascript-client?view=aspnetcore-8.0&tabs=visual-studio#bsleep */
    #keepAliveLock

    /** onConnected() */
    onConnected;

    /** onConnectionFailed(err) */
    onConnectionFailed;

    /** onDisconnected() */
    onDisconnected;

    /** onSubscribeError(EventName, err) */
    onSubscribeError;

    /** onSubscribed(EventName) 
     * Occurs after a successful event subscription
     */
    onSubscribed;

    /** onSubscribing(EventName) 
     * Occurs just before an event subscription is requested
     */
    onSubscribing;

    constructor() {
        this.#connection = new signalR.HubConnectionBuilder().withUrl(EventHub.URL).build();
        this.#subscribedEvents = { };

        this.#connection.onclose(async () => {
            if (this.onDisconnected) this.onDisconnected();
            this.start();
        });
    }

    get connection() { return this.#connection; }


    subscribe(eventName, args, eventCallback) {
        // Save the subscription so that we can send a subscription 
        // request when the connection is established
        this.#subscribedEvents[eventName] = args;

        // Setup the callback
        this.#connection.on(eventName, eventCallback);
    }

    unsubscribe(eventName) {
        delete this.#subscribedEvents[eventName];
        this.#connection.off(eventName);
    }

    /** Start the SignalR connection. Subscribe to all events first.*/
    async start() {
        try {

            if (!this.#keepAliveLock) {
                try {
                    if (navigator && navigator.locks && navigator.locks.request) {
                        const promise = new Promise((res) => {
                            this.#keepAliveLock = res;
                        });

                        navigator.locks.request(crypto.randomUUID(), { mode: "shared" }, () => {
                            return promise;
                        });
                    }
                } catch { }
            }

            await this.#connection.start();
            if (this.onConnected) this.onConnected();

            // send subscription requests
            for (var sub in this.#subscribedEvents) {
                try {
                    if (this.#subscribedEvents.hasOwnProperty(sub)) {
                        if (this.onSubscribing) this.onSubscribing(sub);
                        await this.#connection.invoke(EventHub.SUBSCRIBE, { eventName: sub, args: this.#subscribedEvents[sub] });
                        if (this.onSubscribed) this.onSubscribed(sub);
                    }
                } catch (e) {
                    if (this.onSubscribeError) this.onSubscribeError(sub, e);
                }
            }


        } catch (e) {
            if (this.onConnectionFailed) this.onConnectionFailed(e);
            setTimeout(this.start.bind(this), 5000);
        }
    }

    async stop() {
        try {
            if (this.#keepAliveLock) {
                this.#keepAliveLock();
            }
        } catch { }
        await this.#connection.stop();
    }

}